export default function ResponsiveDrawer({
    open,
    onClose,
    children,
}) {
    return (
        <>
            <div
                className={`responsive-drawer-backdrop ${open ? 'open' : ''}`.trim()}
                onClick={onClose}
                aria-hidden={open ? 'false' : 'true'}
            />
            <div className={`responsive-drawer-shell ${open ? 'open' : ''}`.trim()}>
                {children}
            </div>
        </>
    )
}
